<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jITprz/tc-custom/9780715335406.jpg?1729379451105" alt="This image is the cover for the book Knitted Throws & Cushions, The Knitter's Bible"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Knitted Throws & Cushions, The Knitter's Bible
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The established designer and bestselling author combines fabulous colors and textures with twenty-five stylish patterns that create striking home accessories.</b><br/>  <br/><i>The Knitter’s Bible: Knitted Throws &amp; Cushions</i> features an inspiring collection of knitted projects to brighten up the home, from luxury afghans and bedspreads to functional cushions and seating. The styles vary from basic beginner projects such as cushions and chunky throws to more advanced bedspreads and textured wall hangings.<br/> Inside, you’ll:<br/> · Discover the design secrets behind each project and choose color schemes to incorporate the projects into your own interior style<br/> · Experiment with eye-catching embellishments, sumptuous yarns and easy-to-follow techniques to simply beautify your home<br/>  <br/> Knitting for your home is a lovely way to add a touch of handmade beauty to your interiors, add drama for a party, and dress up your furniture in colors that match the seasons.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claire Crompton
      </h2>
      
      <p class="authorDescription body article"> Claire Crompton has worked as a pattern cutter, sample garment maker, and a hand-knitting designer and pattern writer. She has also worked as a cross stitch designer for a large needlecraft company, developing skills in charting and writing embroidery instructions for kits and booklets. Claire is now a workshop tutor and author of several books on cross stitch and knitting, including the bestsellingKnitter&#39;s Bible series. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David and Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7eb522a7